import { IntegrationErrorApiResponse } from '../@types';
import aqilaApi from './aqila-api';
import {
  DEFAULT_SYNC_AGROGESTAO_SUMMARY,
  mapSyncAgrogestaoItem,
} from '../features/integration-errors/utils';

export type SyncAgrogestaoParams = {
  status?: string;
  from?: string;
  to?: string;
  search?: string;
  page?: number;
  perPage?: number;
};

class SyncAgrogestaoService {
  private readonly endpoint = 'v2/sync_agrogestao';

  private readonly PER_PAGE = 20;

  async list(params: SyncAgrogestaoParams = {}) {
    const { data } = await aqilaApi.get<IntegrationErrorApiResponse>(
      this.endpoint,
      {
        params: {
          page: 1,
          perPage: this.PER_PAGE,
          ...params,
        },
      },
    );

    return {
      summary: data.summary ?? DEFAULT_SYNC_AGROGESTAO_SUMMARY,
      pagination: data.pagination,
      data: data.data.map((item) => mapSyncAgrogestaoItem(item)),
    };
  }
}

export default new SyncAgrogestaoService();
